export const CLIENT_CREATE_RESET = 'CLIENT_CREATE_RESET'
export const CLIENT_CREATE_SET_CREATED = 'CLIENT_CREATE_SET_CREATED'
export const CLIENT_CREATE_SET_ERROR = 'CLIENT_CREATE_SET_ERROR'
export const CLIENT_CREATE_SET_VIOLATIONS = 'CLIENT_CREATE_SET_VIOLATIONS'
export const CLIENT_CREATE_TOGGLE_LOADING = 'CLIENT_CREATE_TOGGLE_LOADING'
